import { objectMap } from 'fast-loops';
import colors from './colors.js';
var fonts = {
  HEADING: 'Pangea, sans-serif',
  BODY: 'Pangea Text, sans-serif'
};
var rawBreakpointSizes = {
  small: 560,
  medium: 800,
  large: 1024,
  huge: 1300
};
var breakpointSizes = objectMap(rawBreakpointSizes, function (value) {
  return value + 'px';
});
export default {
  colors: colors,
  tokens: {
    inputPaddingVertical: 16,
    inputPaddingHorizontal: 16,
    buttonPaddingVertical: 18,
    buttonPaddingHorizontal: 28,
    buttonCompactPaddingVertical: 8,
    buttonCompactPaddingHorizontal: 12,
    cornersSmall: 6,
    cornersLarge: 12
  },
  baselineGrid: 4,
  maxContentWidth: 1280,
  maxReadWidth: 520,
  unsubscribeInfoWidth: 680,
  outerPadding: [4, 4, 6, 8, 8],
  rawBreakpointSizes: rawBreakpointSizes,
  breakpointSizes: breakpointSizes,
  breakpoints: {
    small: "@media (min-width: ".concat(breakpointSizes.small, ")"),
    medium: "@media (min-width: ".concat(breakpointSizes.medium, ")"),
    large: "@media (min-width: ".concat(breakpointSizes.large, ")"),
    huge: "@media (min-width: ".concat(breakpointSizes.huge, ")")
  },
  fonts: fonts,
  typography: {
    oak: {
      fontFamily: fonts.HEADING,
      fontWeight: 500,
      fontSize: 72,
      lineHeight: 86 / 72
    },
    pine: {
      fontFamily: fonts.HEADING,
      fontWeight: 500,
      fontSize: 56,
      lineHeight: 68 / 56
    },
    fir: {
      fontFamily: fonts.HEADING,
      fontWeight: 500,
      fontSize: 40,
      lineHeight: 48 / 40
    },
    beech: {
      fontFamily: fonts.HEADING,
      fontWeight: 500,
      fontSize: 28,
      lineHeight: 36 / 28
    },
    ceder: {
      fontFamily: fonts.HEADING,
      fontSize: 24,
      lineHeight: 32 / 24,
      letterSpacing: 0.6,
      variants: {
        standard: {
          fontWeight: 400
        },
        emphasis: {
          fontWeight: 500
        }
      }
    },
    ash: {
      fontFamily: fonts.HEADING,
      fontSize: 20,
      lineHeight: 28 / 20,
      letterSpacing: 0.6,
      variants: {
        standard: {
          fontWeight: 400
        },
        emphasis: {
          fontWeight: 500
        }
      }
    },
    maple: {
      fontFamily: fonts.BODY,
      fontSize: 16,
      lineHeight: 24 / 16,
      fontWeight: 500
    },
    spruce: {
      fontFamily: fonts.BODY,
      fontSize: 16,
      lineHeight: 24 / 16,
      variants: {
        standard: {
          fontWeight: 400
        },
        emphasis: {
          fontWeight: 500
        },
        ui: {
          fontWeight: 400,
          lineHeight: 1
        }
      }
    },
    birch: {
      fontFamily: fonts.BODY,
      fontSize: 14,
      lineHeight: 20 / 14,
      variants: {
        standard: {
          fontWeight: 400
        },
        emphasis: {
          fontWeight: 500
        }
      }
    },
    cherry: {
      fontFamily: fonts.BODY,
      fontSize: 12,
      lineHeight: 18 / 12,
      variants: {
        standard: {
          fontWeight: 400
        },
        emphasis: {
          fontWeight: 500
        }
      }
    },
    willow: {
      fontFamily: fonts.HEADING,
      fontSize: 20,
      // there is no italic pangea
      // fontStyle: 'italic',
      lineHeight: 28 / 20,
      fontWeight: 400
    }
  }
};